export default {"src":"/_next/static/media/mask-group.8d302789.svg","height":776,"width":911};